import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Menu, X, Gem } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const links = [
  { label: "Home", href: "#home" },
  { label: "Crypto", href: "#crypto" },
  { label: "Forex", href: "#forex" },
  { label: "Trends", href: "#trends" },
  { label: "About", href: "#about" },
  { label: "Roadmap", href: "#roadmap" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const dash = user && user.role === "admin" ? "/admin" : "/portal";

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled ? "glass border-b border-amber-500/20" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 h-20 flex items-center justify-between">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-2">
          <div className="w-10 h-10 rounded-xl gold-btn grid place-items-center">
            <Gem className="w-5 h-5 text-black" />
          </div>
          <div className="leading-tight">
            <div className="font-display font-extrabold text-lg tracking-tight">
              Money<span className="gold-text">MoonX</span>
            </div>
            <div className="text-[9px] uppercase tracking-[0.25em] text-amber-500/70">Global Wealth</div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-7">
          {links.map((l) => (
            <a key={l.href} href={l.href} className="text-sm text-slate-300 hover:text-amber-400 transition-colors font-medium">
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          {user ? (
            <button data-testid="nav-dashboard-btn" onClick={() => navigate(dash)} className="gold-btn px-5 py-2.5 rounded-xl text-sm font-bold">
              Dashboard
            </button>
          ) : (
            <>
              <Link to="/login" data-testid="nav-login-btn" className="text-sm text-amber-300 hover:text-amber-200 border border-amber-500/30 hover:border-amber-400 px-5 py-2.5 rounded-xl transition-all">
                Login
              </Link>
              <Link to="/register" data-testid="nav-register-btn" className="gold-btn px-5 py-2.5 rounded-xl text-sm font-bold">
                Get Started
              </Link>
            </>
          )}
        </div>

        <button data-testid="mobile-menu-btn" className="lg:hidden text-amber-400" onClick={() => setOpen(!open)}>
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden glass border-t border-amber-500/20 px-6 py-4 space-y-3">
          {links.map((l) => (
            <a key={l.href} href={l.href} onClick={() => setOpen(false)} className="block text-slate-300 hover:text-amber-400 py-1">
              {l.label}
            </a>
          ))}
          <div className="flex gap-3 pt-2">
            {user ? (
              <button onClick={() => navigate(dash)} className="gold-btn flex-1 py-2.5 rounded-xl text-sm font-bold">Dashboard</button>
            ) : (
              <>
                <Link to="/login" className="flex-1 text-center border border-amber-500/30 py-2.5 rounded-xl text-amber-300">Login</Link>
                <Link to="/register" className="gold-btn flex-1 text-center py-2.5 rounded-xl font-bold">Get Started</Link>
              </>
            )}
          </div>
        </div>
      )}
    </header>
  );
}
